/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChannelTrendPointFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ChannelTrendPoint, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/orders/by-channel
 */
export interface ByChannelRequestBuilder extends BaseRequestBuilder<ByChannelRequestBuilder> {
    /**
     * Orders in each day, week or month of the window, split by where they came from: the sales app, the storefront, or anywhere else — chiefly orders brought in by an import. A storefront cart a rep reviews and submits still counts as storefront. Every bucket is returned, oldest first, zero-filled, counted in the requested time zone.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChannelTrendPoint[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ByChannelRequestBuilderGetQueryParameters> | undefined) : Promise<ChannelTrendPoint[] | undefined>;
    /**
     * Orders in each day, week or month of the window, split by where they came from: the sales app, the storefront, or anywhere else — chiefly orders brought in by an import. A storefront cart a rep reviews and submits still counts as storefront. Every bucket is returned, oldest first, zero-filled, counted in the requested time zone.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ByChannelRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Orders in each day, week or month of the window, split by where they came from: the sales app, the storefront, or anywhere else — chiefly orders brought in by an import. A storefront cart a rep reviews and submits still counts as storefront. Every bucket is returned, oldest first, zero-filled, counted in the requested time zone.
 */
export interface ByChannelRequestBuilderGetQueryParameters {
    /**
     * The width of each point: Day, Week (weeks start on Monday) or Month. Defaults to Month.
     */
    bucket?: string;
    /**
     * End of the window, inclusive. At most two years after the start.
     */
    endDate?: Date;
    /**
     * Start of the window, inclusive.
     */
    startDate?: Date;
    /**
     * IANA time zone the days are counted in, e.g. America/New_York. Defaults to UTC; an unknown zone falls back to UTC.
     */
    timeZone?: string;
}
/**
 * Uri template for the request builder.
 */
export const ByChannelRequestBuilderUriTemplate = "{+baseurl}/api/analytics/orders/by-channel?bucket={bucket}&endDate={endDate}&startDate={startDate}{&timeZone*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ByChannelRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ByChannelRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createChannelTrendPointFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
